import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import HeaderTitleBar from '../HeaderTitleBar';
import FormTextInput from '../formHelpers/FormTextInput';
import FormStatesSelectBox from '../formHelpers/FormStatesSelectBox';
import FormSubmissionResult from '../formHelpers/FormSubmissionResult';

import 'tailwindcss/tailwind.css';
import { addCompany } from '../../features/companies/companiesSlice';

const CreateCompany = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: '',
    phone_number: '',
    address_1: '',
    address_2: '',
    city: '',
    zip: '',
    state_id: 0,
    pay_rate: 0.0
  });

  const { success, error } = useSelector((state) => state.companies);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = 'Company Name is required';
    }

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newData = formData;
    newData[name] = value;

    setFormData(newData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors({});
    if (validateForm()) {
      dispatch(addCompany({ formData, navigate }));
    }
  };

  const handleBack = () => {
    navigate('/companies')
  }

  return (
    <div className="p-4 mb-6 bg-white shadow rounded-lg">
      <HeaderTitleBar
        title={'Create Company'}
        showBtn={true}
        btnTitle={'Back'}
        btnClick={handleBack}
      />

      <FormSubmissionResult
        successText={`Company "${formData.name}" Created`}
        success={success}
        error={error}
      />

      <form onSubmit={handleSubmit} className="space-y-4 mt-6 w-1/4">
        <FormTextInput
          label={'Company Name'}
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter Company Name"
          formErrors={formErrors}
        />

        <FormTextInput
          label={'Phone Number'}
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          placeholder="Enter a Phone Number"
          formErrors={formErrors}
        />

        <FormTextInput
          label={'Address 1'}
          name="address_1"
          value={formData.address_1}
          onChange={handleChange}
          placeholder="Enter an Address"
          formErrors={formErrors}
        />

        <FormTextInput
          label={'Address (continued)'}
          name="address_2"
          value={formData.address_2}
          onChange={handleChange}
          placeholder="Enter an Address (continued)"
          formErrors={formErrors}
        />

        <FormTextInput
          label={'City'}
          name="city"
          value={formData.city}
          onChange={handleChange}
          placeholder="Enter a City"
          formErrors={formErrors}
        />

        <FormStatesSelectBox
          state_id={formData.state?.id || 0}
          required={false}
          formErrors={formErrors}
          onChange={handleChange}
        />

        <FormTextInput
          label={'Zip'}
          name="zip"
          value={formData.city}
          onChange={handleChange}
          placeholder="Enter a Zip Code"
          formErrors={formErrors}
        />

        <FormTextInput
          label={'Pay Rate %'}
          name="pay_rate"
          value={formData.pay_rate}
          onChange={handleChange}
          placeholder="Enter a Pay Rate Percentage"
          formErrors={formErrors}
        />

        <div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Create Company
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateCompany;